import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import _ from 'lodash';

const emptyObject = {};

// export interface ReactEmbeddedControlProps {
//     className?: string;
//     id: string;
//     idClassName?: string;
//     linkHrefs: string[];
//     scriptSrcs: string[];
//     afterLoad: () => void;
// }
// export const ReactEmbeddedControl: React.FC<ReactEmbeddedControlProps> = ({
export const ReactEmbeddedControl = ({
  linkHrefs,
  scriptSrcs,
  idClassName = '',
  className = '',
  id,
  afterLoad,
}) => {
  const [start, setStart] = useState(emptyObject);
  // const ref = useRef<HTMLDivElement>();
  const ref = useRef();

  // const [booking, setBooking] = useState<{
  //     count: number;
  //     values: boolean[];
  //     links: string[];
  //     afterLoad: () => void;
  // }>(undefined);

  const [booking, setBooking] = useState(undefined);

  const links = useMemo(
    () => {
      return _.orderBy([...linkHrefs, ...scriptSrcs], (d) => d, 'asc');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // eslint-disable-next-line react-hooks/exhaustive-deps
      _.join(
        _.orderBy([...linkHrefs, ...scriptSrcs], (d) => d, 'asc'),
        '#####'
      ),
    ]
  );

  useEffect(() => {
    setStart(emptyObject);
    setBooking({
      count: links.length,
      values: links.map((d) => false),
      links,
      afterLoad,
    });
    setStart({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [links]);

  const onLoad = useCallback(
    // (link: string) => {
    (link) => {
      if (!booking) return;

      const linkFoundIndex = booking.links.findIndex((d) => d === link);
      if (linkFoundIndex > -1) {
        booking.values[linkFoundIndex] = true;
      }

      if (booking.values.filter((d) => d === true).length === booking.count)
        booking.afterLoad();
    },
    [booking]
  );

  const linkHrefsOnLoad = useMemo(() => {
    return linkHrefs.map((linkHref) => {
      // return (): void => {
      return () => {
        onLoad(linkHref);
      };
    });
  }, [onLoad, linkHrefs]);

  const scriptSrcsOnLoad = useMemo(() => {
    return scriptSrcs.map((src) => {
      // return (): void => {
      return () => {
        onLoad(src);
      };
    });
  }, [onLoad, scriptSrcs]);

  useEffect(() => {
    if (start === emptyObject) return;

    // const externalLinks: HTMLLinkElement[] = [];
    const externalLinks = [];
    linkHrefs.forEach((link, index) => {
      const externalLink = document.createElement('link');
      externalLink.href = link;
      externalLink.rel = 'stylesheet';
      externalLink.type = 'text/css';
      ref.current.append(externalLink);

      externalLinks.push(externalLink);
      linkHrefsOnLoad[index]();
    });

    // const externalScripts: HTMLScriptElement[] = [];
    const externalScripts = [];
    scriptSrcs.forEach((script, index) => {
      const externalScript = document.createElement('script');
      externalScript.src = script;
      externalScript.async = true;
      externalScript.onload = scriptSrcsOnLoad[index];
      ref.current.append(externalScript);

      externalScripts.push(externalScript);
    });

    return () => {
      externalLinks.forEach((link) => {
        link.remove();
      });

      externalScripts.forEach((script) => {
        script.remove();
      });
    };
  }, [start, linkHrefs, scriptSrcs, linkHrefsOnLoad, scriptSrcsOnLoad]);

  // if (start === emptyObject) return <div>...Loading</div>;

  return (
    <React.Fragment>
      <div className={className}>
        <div id={id} className={idClassName}></div>
      </div>
      <div ref={ref}></div>
      {/* {linkHrefs.map((d, index) => {
                return (
                    <link key={index} href={d} rel="stylesheet" type="text/css" onLoad={linkHrefsOnLoad[index]}></link>
                );
            })}
            {scriptSrcs.map((d, index) => {
                return <script key={index} src={d} onLoad={scriptSrcsOnLoad[index]}></script>;
            })} */}
    </React.Fragment>
  );
};

export const ReactEmbeddedControlWithMemo = React.memo(
  ReactEmbeddedControl,
  (prevProps, nextProps) => {
    const prevLinks = _.orderBy(
      [...prevProps.linkHrefs, ...prevProps.scriptSrcs],
      (d) => d,
      'asc'
    );
    const nextLinks = _.orderBy(
      [...nextProps.linkHrefs, ...nextProps.scriptSrcs],
      (d) => d,
      'asc'
    );

    return prevLinks === nextLinks;
  }
);



// WEBPACK FOOTER //
// ./src/components/script-loader/react-embedded-control.js